import React, { lazy, Suspense } from "react";
import { Outlet, Navigate, useRoutes } from "react-router-dom";

import DashboardLayout from "@/layouts/dashboard";
import {
  ROUTE_ABOUT,
  ROUTE_ASSISTANCES,
  ROUTE_ASSISTANCES_SHOW,
  ROUTE_CLIENTS,
  ROUTE_DEVICE_ERROR,
  ROUTE_DUPLICATED_TAB,
  ROUTE_LOG,
  ROUTE_LOGIN,
  ROUTE_NO_GEOLOCATION,
  ROUTE_NO_STORAGE,
  ROUTE_NOT_AUTH,
  ROUTE_NOT_FOUND,
  ROUTE_SEARCH,
  ROUTE_SEARCH_COMMAND,
  ROUTE_STAMPING,
  ROUTE_TEAMS,
  ROUTE_USERS,
  ROUTE_LOG_ANALYTICS
} from "@/utils/context/constants";
import MinimalLayout from "@/layouts/minimal";

export const DashboardPage = lazy(() => import("@/pages/app"));
export const StampingPage = lazy(() => import("@/pages/stamping"));
export const UserPage = lazy(() => import("@/pages/user"));
export const LoginPage = lazy(() => import("@/pages/login"));
export const TeamPage = lazy(() => import("@/pages/teams"));
export const ClientPage = lazy(() => import("@/pages/client"));
export const AssistancePage = lazy(() => import("@/pages/assistance"));
export const SearchPage = lazy(() => import("@/pages/search"));
export const Page404 = lazy(() => import("@/pages/page-not-found"));
export const Page401 = lazy(() => import("@/pages/page-not-auth"));
export const PageDuplicatedTab = lazy(() => import("@/pages/page-duplicated-tab"));
export const PageNoStorage = lazy(() => import("@/pages/page-no-storage"));
export const PageNoGeolocation = lazy(() => import("@/pages/page-no-geolocation"));
export const PageDeviceError = lazy(() => import("@/pages/page-device-error"));

export const PageAbout = lazy(() => import("@/pages/about"));

export const PageLog = lazy(() => import("@/pages/log"));
export const PageLogAnalytics = lazy(() => import("@/pages/log-analytics"));

// ----------------------------------------------------------------------

export default function Router() {
  const routes = useRoutes([
    {
      element: (
        <DashboardLayout>
          <Suspense fallback={<React.Fragment />}>
            <Outlet />
          </Suspense>
        </DashboardLayout>
      ),
      children: [
        { element: <DashboardPage />, index: true },
        { path: ROUTE_USERS, element: <UserPage /> },
        { path: ROUTE_TEAMS, element: <TeamPage /> },
        { path: ROUTE_CLIENTS, element: <ClientPage /> },
        { path: ROUTE_ASSISTANCES, element: <AssistancePage /> },
        { path: ROUTE_ASSISTANCES_SHOW, element: <AssistancePage /> },
        { path: ROUTE_SEARCH, element: <SearchPage /> },
        { path: ROUTE_SEARCH_COMMAND, element: <SearchPage /> },
        { path: ROUTE_ABOUT, element: <PageAbout /> },
        { path: ROUTE_LOG, element: <PageLog /> },
        { path: ROUTE_LOG_ANALYTICS, element: <PageLogAnalytics /> }
      ]
    },
    {
      element: (
        <MinimalLayout>
          <Suspense fallback={<React.Fragment />}>
            <Outlet />
          </Suspense>
        </MinimalLayout>
      ),
      children: [
        { path: ROUTE_STAMPING, element: <StampingPage /> },
      ]
    },
    {
      path: ROUTE_LOGIN,
      element: <LoginPage />
    },
    { path: ROUTE_STAMPING, element: <StampingPage /> },
    { path: ROUTE_USERS, element: <UserPage /> },
    { path: ROUTE_TEAMS, element: <TeamPage /> },
    { path: ROUTE_CLIENTS, element: <ClientPage /> },
    { path: ROUTE_ASSISTANCES, element: <AssistancePage /> },
    { path: ROUTE_ASSISTANCES_SHOW, element: <AssistancePage /> },
    { path: ROUTE_SEARCH, element: <SearchPage />},
    { path: ROUTE_SEARCH_COMMAND, element: <SearchPage />},
    {
      path: ROUTE_NOT_AUTH,
      element: <Page401 />
    },
    {
      path: ROUTE_NOT_FOUND,
      element: <Page404 />
    },
    {
      path: ROUTE_DUPLICATED_TAB,
      element: <PageDuplicatedTab />
    },
    {
      path: ROUTE_NO_STORAGE,
      element: <PageNoStorage />
    },
    {
      path: ROUTE_NO_GEOLOCATION,
      element: <PageNoGeolocation />
    },
    {
      path: ROUTE_ABOUT,
      element: <PageAbout />
    },
    {
      path: ROUTE_DEVICE_ERROR,
      element: <PageDeviceError />
    },
    {
      path: ROUTE_LOG,
      element: <PageLog />
    },
    {
      path: ROUTE_LOG_ANALYTICS,
      element: <PageLogAnalytics />
    },
    {
      path: "*",
      element: <Navigate to={ROUTE_NOT_FOUND} replace />
    }
  ]);

  return routes;
}
